import React from 'react';
import HeroSection from './pdp/HeroSection';
import ProblemSection from './pdp/ProblemSection';
import SolutionSection from './pdp/SolutionSection';
import BenefitsSection from './pdp/BenefitsSection';
import TestimonialsSection from './pdp/TestimonialsSection';
import OfferSection from './pdp/OfferSection';
import FaqSection from './pdp/FaqSection';
import FinalCta from './pdp/FinalCta';
const ProductDetailPage = () => {
  return <div className="w-full bg-white" data-id="element-282">
      <HeroSection data-id="element-283" />
      <div className="py-4 md:py-6" data-id="element-284"></div> {/* Increased spacing */}
      <ProblemSection data-id="element-285" />
      <div className="py-4 md:py-6" data-id="element-286"></div> {/* Increased spacing */}
      <SolutionSection data-id="element-287" />
      <div className="py-4 md:py-6" data-id="element-288"></div> {/* Increased spacing */}
      <BenefitsSection data-id="element-289" />
      <div className="py-4 md:py-6" data-id="element-290"></div> {/* Increased spacing */}
      <TestimonialsSection data-id="element-291" />
      <div className="py-4 md:py-6" data-id="element-292"></div> {/* Increased spacing */}
      <OfferSection data-id="element-293" />
      <div className="py-4 md:py-6" data-id="element-294"></div> {/* Increased spacing */}
      <FaqSection data-id="element-295" />
      <div className="py-4 md:py-6" data-id="element-296"></div> {/* Increased spacing */}
      <FinalCta data-id="element-297" />
    </div>;
};
export default ProductDetailPage;